<app-navbar [hide_menu]="true"></app-navbar>
<div class="success-wrapper">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-xl-4 col-lg-5 col-md-8 col-10 py-5">
        <div class="contents text-center">
          <img loading="lazy" src="assets/payment-successful.png" width="80%">
          <h4 class="text-success mt-3">Payment Successful!</h4>
          <small>Invoice Number</small>
          <p class="mb-2" *ngIf="invoice_no">
            <b>{{invoice_no}}</b>
          </p>
          <ng-container *ngIf="alacarte_email">
            <p>
              <small>An email is being sent to <b>{{alacarte_email}}</b> with the QR Code and activation
                instruction.</small>
            </p>
          </ng-container>
          <hr>
          <div class="d-flex justify-content-between">
            <p>Amount Paid:</p>
            <p><b>{{amount_to_pay | currency: currency }}</b></p>
          </div>
          <button class="btn btn-primary btn-block mt-3" (click)="continue()">Continue</button>
        </div>
      </div>
    </div>
  </div>
</div>